
<div aria-label="showallinonepage" *ngIf="outcome">
  <div class="ptb-archive" *ngIf="PendingContentPage" [ngClass]="PendingContentPage ? 'highlightSearchTerm_PCS': 'generalPage pt-104px'">
    <div class="flex-display">
      <div class="cursor-pointer">
        <img src="../../../../assets/icons/Pending.svg" class="pending-image" alt="alarm">
      </div>
      <div class="PendingContent-general-header" tabindex="0">
        {{sectionHeader}}
      </div>
      <div class="text-align-right singleLine">
        <div class="cursor-pointer ">
          <span (click)="EditPCS()" (keyup.enter)="EditPCS()" tabindex="0">
            <a class="anchor-black">Edit</a>
            <img src="../../../../assets/icons/pencil.svg" class="pencil-iconwidth ml-1px underline" alt="alarm">
          </span>
          <span class="ml-2" (click)="ResetPCS()" (keyup.enter)="ResetPCS()" tabindex="0"> <a class="anchor-black">Reset</a></span>
        </div>
      </div>
    </div>
    <div class="ml-2 flex-display">
      <div class="archive-btn" tabindex="0">
        <span class="archive-Info mr-14px">{{showingContent_Label}} {{FiscalDate}}</span>
        <span class="archive-Info mr-14px">{{fillingStatus_Label}}:{{fillingStatus}}</span>
        <span class="archive-Info mr-14px">{{periodTypeLabel}}: {{PeriodType}}</span>

      </div>
    </div>
  </div>
  <div class="padding-content-screen" *ngIf="AllPageData != {}">
    <div class="componentHeader ml-3 print-content-hide">

      <app-breadcrumbs-path [crumbData]="crumbData.slice(0, 2)"></app-breadcrumbs-path>
    </div>
    <div *ngIf="parentlevel" class="generalHeader font-40 mt-invert-2 ml-3  pt-3" role="main" aria-label="aria-parentlevel">
      <span id="pageHeading"> {{mainsectionsectionname}}</span>
    </div>
    <div *ngFor="let section of PublPageIds" [ngClass]="PendingContentPage? '': 'mb-2'">
      <div class="print-all-content">
        <hr *ngIf="parentlevel" class="border-top-section width-87 mx-2" />
        </div>
        <div class="print-all-content ml-3">
          <div id="main-section-name" class="generalHeader font-40">
            {{section.mainsectionname}}
          </div>
          <div id="section-name" class="generalHeader font-40 ml-1">
            {{section.sectionname}}
          </div>
        </div>
        <div *ngFor="let publpageid of section.sectionarray">
          <div *ngIf="(ShowSecContent && publpageid.pageName.startsWith('S')) || (!publpageid.pageName.startsWith('S'))">
            <div class="mt_1" [ngClass]="AllPageData[publpageid.pagetitle]?.contentPageTitle?.split(' ')[0]?.split('-')[2]?.toLowerCase().startsWith('s')?'sec':''">
              <div class="print-all-content">
                <hr class="border-top-heading width-87 mx-2" />
              </div>
              <div class="componentHeader mb-2">
                <div class="ml-invert-1 print-all-content">
                  <h1 role="main" class="generalHeader font-32" aria-label="headingMain" [innerHTML]="AllPageData[publpageid.pagetitle]?.contentPageTitle">
                  </h1>
                </div>
              </div>
              <div *ngIf="AllPageData[publpageid.pagetitle]?.formattedResponse?.length == 0">
                <div *ngFor="let info of AllPageData[publpageid.pagetitle]?.topicBodyContent">
                  <div class="componentHeader print-all-content mb-2">
                    <div class="flex-display mb-24px mt-40px info-box info-box-width">
                      <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
                      <label class="ml-8 para-content content-blue" tabindex="0">
                        <span><span class="bold" [innerHTML]="info?.contentPageTitle"></span><span *ngIf="info?.contentPageTitle!='' || info?.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkByIdGeneralNote($event)" (contextmenu)="onRightClickGeneralNote($event)" (mouseover)="mouseOverFunctionsGeneralNote($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngFor="let para of AllPageData[publpageid.pagetitle]?.formattedResponse; let index = index">
                <div *ngFor="let info of AllPageData[publpageid.pagetitle]?.topicBodyContent">
                  <div class="componentHeader print-all-content mb-2" *ngIf="index == info?.pageInfoPosition">
                    <div class="flex-display mb-24px mt-40px info-box info-box-width">
                      <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="topic info"></div>
                      <label class="ml-8 para-content content-blue" tabindex="0">
                        <span><span class="bold" [innerHTML]="info?.contentPageTitle"></span><span *ngIf="info?.contentPageTitle!='' || info?.contentPageTitle!=null">:</span><span class="generalNote" (click)="openLinkByIdGeneralNote($event)" (contextmenu)="onRightClickGeneralNote($event)" (mouseover)="mouseOverFunctionsGeneralNote($event)" [innerHTML]="info.contentPageBody|safeContentHTML"></span></span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="componentHeader flex-display topicBody print-all-content" *ngIf="para.headingName.topicTitleName != ''">
                  <div class="width-75" tabindex="0" [id]="para?.headingName?.topicTitleId">
                    <h2 class="paraHeader ">
                      <span [innerHTML]="para?.headingName?.topicTitleName|safeContentHTML"></span>
                    </h2>
                  </div>
                  <div class="mt-0-5rem" *ngIf='ASUResponse[publpageid.pagetitle]?.hits?.hitsList?.length > 0'>
                    <div class="float-R">
                      <img src="../../../../assets/icons/Related.svg" class="whatsNew-image image-info" alt="ShowProposedASU">
                      <span class="highlight-blue border-bottom-help cursor-pointer singleLine" (click)="OpenRelatedContent(publpageid.pagetitle)" (keyup.enter)="OpenRelatedContent(publpageid?.pagetitle)" tabindex="0">Related Proposed ASUs </span>
                    </div>
                  </div>
                </div>
                <div class="componentHeader" *ngFor="let paragraph of para.paragraphContent">
                  <div class="componentHeaderPrint print-all-content">
                    <div class="mt_1 width-90" *ngIf="paragraph?.paragroup != ''">
                      <div class="mt_1" [ngClass]="paragraph?.paraTitle == null?'mb-1':'mb-1'">
                        <h3 class="annotation-content-title topicBody" tabindex="0">
                          <span>>&nbsp;</span><span [innerHTML]="paragraph?.paragroup"></span>
                        </h3>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="isPendingContentIntegrated">
                    <pub-dita-content [id]="paragraph?.id" [publicationId]="publpageid?.publid" [pageTitle]="publpageid?.pagetitle" compname="showallinonepage" [dita]="paragraph?.paraContent" [s3ImageBasePath]="s3ImageBasePath" [paraTitle]="paragraph?.paraTitle" printqueueAdd="false" archivePage="false" [paraNum]="paragraph?.paraNum" [PendingContentMerge]="PendingContentMergeList" [BreadcrumbPath]="HistoryCrumbData + '~' + section.mainsectionname + '~' + section.sectionname + '~' + publpageid.pageName" ParentComponent="showAllInOnePage" [crumbData]="(HistoryCrumbData + '~' + section.mainsectionname + '~' + section.sectionname + '~' + publpageid.pageName).split('~')" [UserInfo]="loggedInUserInfo" [pageNums]="publpageid.pagetitle" [pageurl]="publpageid.pageurl" [topic_subtopicNum]="publpageid.pagetitle.split('-')[0] + '-' + publpageid.pagetitle.split('-')[1] + '-'" [preloadContentPage]="preloadContentPage"></pub-dita-content>
                  </div>

                  <div *ngIf="!isPendingContentIntegrated">

                    <div class="print-all-content">
                      <div class="component" [id]="paragraph?.paraNum">
                        <div class="topicBody">

                          <div role="navigation" [attr.aria-label]="paragraph?.id">
                            <div class="row">
                              <div *ngIf="paragraph?.paraTitle[0] != null && paragraph?.paraTitle[0].headingName != ''" class="width-90">
                                <div class="mb-1">
                                  <h4 class="right-overlay-heading">
                                    <span *ngIf="paragraph?.paraNum != ''">&#183;&nbsp;>&nbsp;<span [id]="paragraph?.paraTitle[0]?.headingId" [class.paragraphId]="paragraph?.paraNum == ''" [innerHTML]="paragraph?.paraTitle[0]?.headingName|safeContentHTML"></span></span>
                                    <span *ngIf="paragraph?.paraNum == ''" [id]="paragraph?.id" class="highlight-blue border-bottom-help cursor-pointer singleLine" [innerHTML]="paragraph?.paraTitle[0]?.headingName|safeContentHTML" (click)="redirectToGlossaryTermUsage($event)"></span>
                                  </h4>
                                </div>
                              </div>
                              <div *ngIf="paragraph?.paraTitle[1] != null && paragraph?.paraTitle[1]?.headingName != ''" class="width-90">
                                <div class="mb-1">
                                  <h5 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paragraph?.paraTitle[1]?.headingId" [innerHTML]="paragraph?.paraTitle[1]?.headingName|safeContentHTML"></span></h5>
                                </div>
                              </div>
                              <div *ngIf="paragraph.paraTitle[2] != null && paragraph.paraTitle[2].headingName != ''" class="width-90">
                                <div class="mb-1">
                                  <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paragraph?.paraTitle[2]?.headingId" [innerHTML]="paragraph?.paraTitle[2]?.headingName|safeContentHTML"></span></h6>
                                </div>
                              </div>
                              <div *ngIf="paragraph.paraTitle[3] != null && paragraph.paraTitle[3].headingName != ''" class="width-90">
                                <div class="mb-1">
                                  <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paragraph?.paraTitle[3]?.headingId" [innerHTML]="paragraph?.paraTitle[3]?.headingName|safeContentHTML"></span></h6>
                                </div>
                              </div>
                              <div *ngIf="paragraph.paraTitle[4] != null && paragraph.paraTitle[4].headingName != ''" class="width-90">
                                <div class="mb-1">
                                  <h6 class="right-overlay-heading-h5"><span>&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;&#183;&nbsp;>&nbsp;</span><span [id]="paragraph?.paraTitle[4]?.headingId" [innerHTML]="paragraph?.paraTitle[4]?.headingName|safeContentHTML"></span></h6>
                                </div>
                              </div>
                              <div class="contentShow">
                                <div class="flex-display width-91">
                                  <div class="flex-display width-100">
                                    <div class="paragraphId floatL" [ngClass]="paragraph?.paraNum != null && paragraph?.paraNum != ''?'width-10':'width-2'">{{paragraph.paraNum}}</div>
                                    <div role="region" [attr.aria-label]="((publpageid?.pagetitle == '' ? 'para' : publpageid?.pagetitle) + paragraph.id.replace(' ', '_'))" class="print-content width-90 floatR">
                                      <article tabindex="0" role="article" (contextmenu)="onRightClick($event)" (mouseover)="mouseOverFunctions($event)" id="{{((publpageid.pagetitle == '' ? 'para' : publpageid.pagetitle) + paragraph.id.replace(' ', '_'))}}" class="dita-content" (click)="openLinkById($event,paragraph.paraNum, publpageid.pageurl,publpageid.pagetitle)" [innerHTML]="paragraph.paraContent|safeContentHTML" (keyup.enter)="openLinkById($event,paragraph.paraNum, publpageid.pageurl,publpageid.pagetitle)"></article>
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>
                            <div class="printShow">
                              <div class="containerP width-100 ml-0 d-flex">
                                <div class="pn col-2" style="float: left; width:15%">{{paragraph.paraNum}}</div>
                                <div role="region" class="col-10" style="float: right; width:84%" tabindex="0" [innerHTML]="paragraph?.paraContent|safeContentHTML">
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br />
              <div class="print-all-content">
                <div class="showallinone-ending-space">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div></div>

